<template>
  <nav aria-label="breadcrumb">
    <ol class="breadcrumb">
      <li v-for="(crumb, index) in breadcrumbs" :key="index" class="breadcrumb-item">
        <span v-if="crumb.isCurrent">{{ crumb.label }}</span>
        <router-link v-else :to="crumb.href">{{ crumb.label }}</router-link>
      </li>
    </ol>
  </nav>
</template>

<script setup lang="ts">
import { ref, watch } from 'vue';
import { useRoute } from 'vue-router';

import type { Breadcrumb } from '@/interfaces/breadcrumb';

const route = useRoute();
const breadcrumbs = ref<Breadcrumb[]>([]);

// Function to update breadcrumbs
const updateBreadcrumbs = () => {
  const pathSegments = route.path.split('/').filter(Boolean);
  breadcrumbs.value = pathSegments.map((segment, index) => {
    const href = '/' + pathSegments.slice(0, index + 1).join('/');
    return {
      label: segment.toUpperCase(),
      href,
      isCurrent: index === pathSegments.length - 1,
    };
  });
};

watch(route, updateBreadcrumbs, { immediate: true });
</script>
